import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { AddInvoiceComponent } from "../add-invoice/add-invoice.component";
import { EditInvoiceComponent } from "../edit-invoice/edit-invoice.component";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { AddfuelExpenseComponent } from "../addfuel-expense/addfuel-expense.component";
import { AddDriverExpenseComponent } from "../add-driver-expense/add-driver-expense.component";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-detail-lr",
  templateUrl: "./detail-lr.component.html",
  styleUrls: ["./detail-lr.component.css"],
})
export class DetailLrComponent implements OnInit {
  isTab = "fuelExpense";
  clientName: any;
  vehicles: any;
  InvoiceDetails = [];
  clientList = [];
  particlarLR: any;
  vehiclesDetail: any;
  paramId;
  previewLoadingSlipURL: any;
  apiUrl = environment.domain;
  previewLoadingSlips: string[] = []; // For UI preview
  uploadedFilePaths: string[] = []; // For submission
  trackerId: string;
  @ViewChild("showLoadingSlipPreview") showLoadingSlipPreview: ElementRef;
  @ViewChild("paginator") paginator: MatPaginator;
  displayedColumns: any = [
    "Date",
    "Fuel Quantity",
    "Fuel Type",
    "Amount",
    "Drive Name",
    "Action",
  ];
  driverExpenseColumns: any = [
    "Date",
    "Amount Paid",
    "Payment Mode",
    "Drive Name",
    "Action",
  ];

  dataSource: MatTableDataSource<any>;
  editLR = new FormGroup({
    clientList: new FormControl(""),
    ConsigneeName: new FormControl(""),
    ConsigneeAddress: new FormControl(""),
    ConsignorName: new FormControl(""),
    ConsignorAddress: new FormControl(""),
    VehicleNo: new FormControl(""),
    vehicleType: new FormControl(""),
    from: new FormControl(""),
    to: new FormControl(""),
    GSTIN: new FormControl(""),
    date: new FormControl(""),
    RoadPermitNo: new FormControl(""),
    StateCode: new FormControl(""),
    DLY: new FormControl(""),
    DeclaredValue: new FormControl(""),
    fixAdhoc: new FormControl(""),
    quantity: new FormControl(""),
    transportorName: new FormControl(""),
    transportorMobile: new FormControl(""),
    driverName: new FormControl(""),
    driverMobile: new FormControl(""),
    tollAttachment: new FormControl(""),
    loadingSlipAttchment: new FormControl(""),
    Frieght: new FormControl(""),

    startmeterReading: new FormControl(""),
    endmeterReading: new FormControl(""),
    tripSDate: new FormControl(""),
    tripEDate: new FormControl(""),
    outtime: new FormControl(""),
    INtime: new FormControl(""),
    noofTools: new FormControl(""),
    tooltaxPaid: new FormControl(""),
    labourPaid: new FormControl(""),
    otherPayment: new FormControl(""),
    updownkm: new FormControl(""),
    totalhour: new FormControl(""),
    extrahour: new FormControl(""),
    detention: new FormControl(""),
    advance: new FormControl(""),
    balance: new FormControl(""),
    balancePaid: new FormControl(""),
    vehicleRate: new FormControl(""),
    LR_no: new FormControl("", [Validators.required]),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.paramId = param.id;
      this.getLRDetail(this.paramId);
    });
  }

  ngOnInit(): void {}

  getClientList() {
    this.spinner.show();
    this.superAdminService.getClientList().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status) {
          this.clientList = res.data;

          const clientIdStr = String(this.particlarLR.clientId).trim();

          const matchedClient = this.clientList.find(
            (item) => String(item._id).trim() === clientIdStr
          );
          this.clientName = matchedClient ? matchedClient.clientName : "N/A";
        } else {
          this.toastr.error(res.message || "Failed to fetch clients");
        }
        this.spinner.hide();
      },
      (error) => {
        // console.error("Error fetching clients:", error);
        this.toastr.error("Error fetching clients");
      }
    );
  }

  getLRDetail(id: string) {
    this.spinner.show();

    this.superAdminService.particlarLR(id).subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status && res.data?.length) {
          this.particlarLR = res.data[0];

          this.initform();
        } else {
          this.toastr.error(res.message || "Failed to load LR details");
        }

        this.spinner.hide();
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Failed to load LR details");
      }
    );
  }

  initform() {
    this.editLR.patchValue({
      // Basic Details
      clientList: this.particlarLR.clientName ?? "N/A",
      LR_no: this.particlarLR.LR_no ?? "N/A",
      ConsigneeName: this.particlarLR.consignee_name ?? "N/A",
      ConsigneeAddress: this.particlarLR.consignee_address ?? "N/A",
      ConsignorName: this.particlarLR.consignor_name ?? "N/A",
      ConsignorAddress: this.particlarLR.consignor_address ?? "N/A",
      VehicleNo: this.particlarLR.vehicle_id ?? "N/A",
      vehicleType: this.particlarLR.vehicleType ?? "N/A",
      from: this.particlarLR.from ?? "N/A",
      to: this.particlarLR.to ?? "N/A",
      GSTIN: this.particlarLR.GSTIN ?? "N/A",
      date: this.particlarLR.date
        ? new Date(this.particlarLR.date).toISOString().split("T")[0]
        : "",
      RoadPermitNo: this.particlarLR.road_permit_no ?? "N/A",
      StateCode: this.particlarLR.stateCode ?? "N/A",
      DLY: this.particlarLR.dly_no ?? "N/A",
      DeclaredValue: this.particlarLR.declared_value ?? "N/A",
      fixAdhoc: this.particlarLR.fixAdhoc ?? "N/A",
      quantity: this.particlarLR.quantity ?? "N/A",
      transportorName: this.particlarLR.transportorName ?? "N/A",
      transportorMobile: this.particlarLR.transportorMobile ?? "N/A",
      driverName: this.particlarLR.driverName ?? "N/A",
      driverMobile: this.particlarLR.driverMobile ?? "N/A",
      Frieght: this.particlarLR.Frieght ?? "N/A",

      // Office use only
      startmeterReading: this.particlarLR.startmeterReading ?? 0,
      endmeterReading: this.particlarLR.endmeterReading ?? 0,
      tripSDate: this.particlarLR.tripStartDate
        ? new Date(this.particlarLR.tripStartDate).toISOString().split("T")[0]
        : "",
      tripEDate: this.particlarLR.tripEndDate
        ? new Date(this.particlarLR.tripEndDate).toISOString().split("T")[0]
        : "",
      INtime: this.particlarLR.in_time ?? "",
      outtime: this.particlarLR.out_time ?? "",
      noofTools: this.particlarLR.noofTools ?? 0,
      tooltaxPaid: this.particlarLR.tooltaxPaid ?? 0,
      labourPaid: this.particlarLR.labourPaid ?? 0,
      otherPayment: this.particlarLR.otherPayment ?? 0,
      updownkm: this.particlarLR.up_down_km ?? 0,
      totalhour: this.particlarLR.totalhour ?? 0,
      extrahour: this.particlarLR.extrahour ?? 0,
      detention: this.particlarLR.detention ?? 0,
      advance: this.particlarLR.advance ?? 0,
      balance: this.particlarLR.balance ?? 0,
      balancePaid: this.particlarLR.balancePaid ?? 0,
      vehicleRate: this.particlarLR.vehicleRate ?? 0,
    });
    this.previewLoadingSlips = this.particlarLR.loadingSlipAttchment || [];
    this.uploadedFilePaths = [...this.previewLoadingSlips];
  }

  updateLRSubmit() {
    if (this.editLR.valid) {
      // Basic Details

      this.removevalidatorcss("LR_noctrl");
      this.removevalidatorcss("ConsigneeNamectrl");
      this.removevalidatorcss("ConsigneeAddressctrl");
      this.removevalidatorcss("ConsignorAddressctrl");
      this.removevalidatorcss("ConsignorNamectrl");
      this.removevalidatorcss("VehicleNoctrl");
      this.removevalidatorcss("fromctrl");
      this.removevalidatorcss("toctrl");
      this.removevalidatorcss("GSTINctrl");
      this.removevalidatorcss("datectrl");
      this.removevalidatorcss("startmeterReadingctrl");
      this.removevalidatorcss("endmeterReadingctrl");
      this.removevalidatorcss("outtimectrl");
      this.removevalidatorcss("INtimectrl");
      this.removevalidatorcss("noofToolsctrl");
      this.removevalidatorcss("tooltaxPaidctrl");
      this.removevalidatorcss("labourPaidctrl");
      this.removevalidatorcss("otherPaymentctrl");
      this.removevalidatorcss("updownkmctrl");
      this.removevalidatorcss("totalhourctrl");
      this.removevalidatorcss("vehicleRatectrl");

      const form = {
        _id: this.particlarLR._id,

        ConsigneeName: this.editLR.get("ConsigneeName").value,
        ConsigneeAddress: this.editLR.get("ConsigneeAddress").value,
        ConsignorName: this.editLR.get("ConsignorName").value,
        ConsignorAddress: this.editLR.get("ConsignorAddress").value,
        VehicleNo: this.editLR.get("VehicleNo").value,
        GSTIN: this.editLR.get("GSTIN").value,
        from: this.editLR.get("from").value,
        to: this.editLR.get("to").value,
        date: this.editLR.get("date").value,

        startmeterReading: this.editLR.get("startmeterReading").value,
        endmeterReading: this.editLR.get("endmeterReading").value,
        INtime: this.editLR.get("INtime").value,
        outtime: this.editLR.get("outtime").value,
        noofTools: this.editLR.get("noofTools").value,
        tooltaxPaid: this.editLR.get("tooltaxPaid").value,
        labourPaid: this.editLR.get("labourPaid").value,
        otherPayment: this.editLR.get("otherPayment").value,
        updownkm: this.editLR.get("updownkm").value,
        totalhour: this.editLR.get("totalhour").value,
        vehicleRate: this.editLR.get("vehicleRate").value,

        loadingSlipAttchment: this.uploadedFilePaths,
      };

      this.superAdminService.updateLR({ form }).subscribe(
        (res: { status: any; message: any; authorization: any; code: any }) => {
          if (res.status == true) {
            this.toastr.success(res.message);
            this.router.navigate(["/superAdmin/lrmanagement"]);
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.success(res.message);
            }
          }
        },
        (error) => {}
      );
    } else {
      // Basic Details

      if (this.editLR.get("ConsigneeAddress").invalid) {
        this.addvalidatorcss("ConsigneeAddressctrl");
      } else {
        this.removevalidatorcss("ConsigneeAddressctrl");
      }
      if (this.editLR.get("ConsignorName").invalid) {
        this.addvalidatorcss("ConsignorNamectrl");
      } else {
        this.removevalidatorcss("ConsignorNamectrl");
      }
      if (this.editLR.get("ConsigneeName").invalid) {
        this.addvalidatorcss("ConsigneeNamectrl");
      } else {
        this.removevalidatorcss("ConsigneeNamectrl");
      }
      if (this.editLR.get("ConsignorAddress").invalid) {
        this.addvalidatorcss("ConsignorAddressctrl");
      } else {
        this.removevalidatorcss("ConsignorAddressctrl");
      }
      if (this.editLR.get("VehicleNo").invalid) {
        this.addvalidatorcss("VehicleNoctrl");
      } else {
        this.removevalidatorcss("VehicleNoctrl");
      }
      if (this.editLR.get("from").invalid) {
        this.addvalidatorcss("fromctrl");
      } else {
        this.removevalidatorcss("fromctrl");
      }
      if (this.editLR.get("to").invalid) {
        this.addvalidatorcss("toctrl");
      } else {
        this.removevalidatorcss("toctrl");
      }
      if (this.editLR.get("date").invalid) {
        this.addvalidatorcss("datectrl");
      } else {
        this.removevalidatorcss("datectrl");
      }
      if (this.editLR.get("GSTIN").invalid) {
        this.addvalidatorcss("GSTINctrl");
      } else {
        this.removevalidatorcss("GSTINctrl");
      }

      // Information For office use only

      if (this.editLR.get("startmeterReading").invalid) {
        this.addvalidatorcss("startmeterReadingctrl");
      } else {
        this.removevalidatorcss("startmeterReadingctrl");
      }
      if (this.editLR.get("endmeterReading").invalid) {
        this.addvalidatorcss("endmeterReadingctrl");
      } else {
        this.removevalidatorcss("endmeterReadingctrl");
      }
      if (this.editLR.get("outtime").invalid) {
        this.addvalidatorcss("outtimectrl");
      } else {
        this.removevalidatorcss("outtimectrl");
      }
      if (this.editLR.get("INtime").invalid) {
        this.addvalidatorcss("INtimectrl");
      } else {
        this.removevalidatorcss("INtimectrl");
      }
      if (this.editLR.get("noofTools").invalid) {
        this.addvalidatorcss("noofToolsctrl");
      } else {
        this.removevalidatorcss("noofToolsctrl");
      }
      if (this.editLR.get("tooltaxPaid").invalid) {
        this.addvalidatorcss("tooltaxPaidctrl");
      } else {
        this.removevalidatorcss("tooltaxPaidctrl");
      }
      if (this.editLR.get("labourPaid").invalid) {
        this.addvalidatorcss("labourPaidctrl");
      } else {
        this.removevalidatorcss("labourPaidctrl");
      }
      if (this.editLR.get("otherPayment").invalid) {
        this.addvalidatorcss("otherPaymentctrl");
      } else {
        this.removevalidatorcss("otherPaymentctrl");
      }
      if (this.editLR.get("updownkm").invalid) {
        this.addvalidatorcss("updownkmctrl");
      } else {
        this.removevalidatorcss("updownkmctrl");
      }
      if (this.editLR.get("totalhour").invalid) {
        this.addvalidatorcss("totalhourctrl");
      } else {
        this.removevalidatorcss("totalhourctrl");
      }
      if (this.editLR.get("vehicleRate").invalid) {
        this.addvalidatorcss("vehicleRatectrl");
      } else {
        this.removevalidatorcss("vehicleRatectrl");
      }
    }
  }

  addvalidatorcss(id: string) {
    document.getElementById(id).classList.add("validatorcss");
  }
  removevalidatorcss(id: string) {
    document.getElementById(id).classList.remove("validatorcss");
  }

  addnewinv(acc) {
    const dialogRef = this.dialog.open(AddInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        getLrDetail: () => {
          this.getLRDetail(this.paramId);
        },
      },
    });
  }
  editInvoice(acc, id, trackerId: string): void {
    this.dialog.open(EditInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        id,
        trackerId,
        getLrDetail: () => {
          this.getLRDetail(id);
        },
      },
    });
  }

  previewLoadingSlip(imageUrl: any, backImageUrl: any) {
    const url = imageUrl;
    const backUrl = backImageUrl;
    if (url) {
      let fileExtension = url.split(".").slice(-1)[0];
      if (["jpeg", "png", "jpg", "svg"].includes(fileExtension)) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: url, backFile: backUrl },
        });
      }
    } else {
      this.toastr.error("No attachment");
    }
  }
  expenseTab(tabname: any) {
    this.isTab = tabname;
  }
  sortData(sort: Sort) {}
  addExpence() {
    const dialogRef = this.dialog.open(AddfuelExpenseComponent, {
      panelClass: ["addexpenceLoading", "addexpensefuel"],
      data: this.paramId,
    });
  }
  driverExpence() {
    const dialogRef = this.dialog.open(AddDriverExpenseComponent, {
      panelClass: ["addexpenceLoading", "addexpensefuel"],
    });
  }
  backTo() {
    window.history.back();
  }
}
